/*
  ST 2026-09-10 — Hide sticky add-to-cart form on mobile when product-form-wrapper or footer-group is in viewport.
  
  Detects when .product-form-wrapper or .footer-group enters the viewport on mobile (<1280px) and hides 
  .product-sticky-form by toggling body.st-sticky-form-hidden class.
  
  Rollback: remove this file and the stylesheet_tag in theme.liquid, and the related CSS.
*/
(function () {
  'use strict';

  var body = document.body;
  var mobileOnly = window.matchMedia ? window.matchMedia('(max-width: 1279px)') : null;

  // Early return if no mobile query support or on desktop
  if (!mobileOnly || mobileOnly.matches === false) return;

  var productFormWrapper = document.querySelector('.product-form-wrapper');
  var footerGroup = document.querySelector('.footer-group');

  if (!productFormWrapper && !footerGroup) return;

  // Use Intersection Observer if available (modern browsers)
  if ('IntersectionObserver' in window) {
    var updateStickyFormVisibility = function () {
      var productFormInViewport = false;
      var footerInViewport = false;

      if (productFormWrapper) {
        var productFormRect = productFormWrapper.getBoundingClientRect();
        productFormInViewport = productFormRect.top < window.innerHeight && productFormRect.bottom >= 0;
      }

      if (footerGroup) {
        var footerRect = footerGroup.getBoundingClientRect();
        footerInViewport = footerRect.top < window.innerHeight && footerRect.bottom >= 0;
      }

      // Hide sticky form if EITHER element is in viewport
      if (productFormInViewport || footerInViewport) {
        body.classList.add('st-sticky-form-hidden');
      } else {
        body.classList.remove('st-sticky-form-hidden');
      }
    };

    var observer = new IntersectionObserver(updateStickyFormVisibility, { threshold: 0 });

    if (productFormWrapper) observer.observe(productFormWrapper);
    if (footerGroup) observer.observe(footerGroup);
  } else {
    // Fallback for older browsers: check on scroll
    function checkElementsVisibility() {
      var productFormInViewport = false;
      var footerInViewport = false;

      if (productFormWrapper) {
        var productFormRect = productFormWrapper.getBoundingClientRect();
        productFormInViewport = productFormRect.top < window.innerHeight && productFormRect.bottom >= 0;
      }

      if (footerGroup) {
        var footerRect = footerGroup.getBoundingClientRect();
        footerInViewport = footerRect.top < window.innerHeight && footerRect.bottom >= 0;
      }

      // Hide sticky form if EITHER element is in viewport
      if (productFormInViewport || footerInViewport) {
        body.classList.add('st-sticky-form-hidden');
      } else {
        body.classList.remove('st-sticky-form-hidden');
      }
    }

    window.addEventListener('scroll', checkElementsVisibility, { passive: true });
    window.addEventListener('resize', checkElementsVisibility, { passive: true });

    // Initial check
    checkElementsVisibility();
  }
})();
